'use client';

import { c as _c } from "react/compiler-runtime";
import SectionErrorBoundary from '../common/SectionErrorBoundary';
import DashboardBorrowPositions from './DashboardBorrowPositions/DashboardBorrowPositions';
import DashboardBorrowPositionsError from './DashboardBorrowPositions/states/DashboardBorrowPositionsError';
import DashboardEarnPositions from './DashboardEarnPositions/DashboardEarnPositions';
import DashboardEarnPositionsError from './DashboardEarnPositions/states/DashboardEarnPositionsError';
import DashboardLendPositions from './DashboardLendPositions/DashboardLendPositions';
import DashboardSectionDivider from './DashboardSectionDivider';
const DashboardPositions = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DashboardEarnPositionsError />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SectionErrorBoundary title="Error loading Vaults positions data" description="Something went wrong while loading Vaults positions data" fallback={t0} route="/portfolio"><DashboardEarnPositions /></SectionErrorBoundary>;
    t2 = <DashboardSectionDivider />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DashboardBorrowPositionsError />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SectionErrorBoundary title="Error loading Variable Rate Markets positions data" description="Something went wrong while loading Variable Rate Markets positions data" fallback={t3} route="/portfolio"><DashboardBorrowPositions /></SectionErrorBoundary>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <>{t1}{t2}<div className="flex flex-col gap-12">{t4}<SectionErrorBoundary fallback={null} section="DashboardLendPositions" route="/portfolio"><DashboardLendPositions /></SectionErrorBoundary></div></>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default DashboardPositions;